<template>
    <div class="page-container">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="info-form" label-width="auto">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item ref="p_name" label="申报项目名称" prop="p_name">
                        <el-input v-model="ruleForm.p_name" :disabled="readonly" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="p_code" label="申报项目编码" prop="p_code">
                        <el-input v-model="ruleForm.p_code" :disabled="readonly" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="p_mid" label="项目类别" prop="cate">
                        <el-select v-model="ruleForm.cate" :disabled="readonly" multiple placeholder="请选择">
                            <el-option
                                v-for="item in classifys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item ref="client" label="委托单位" prop="client">
                        <el-autocomplete v-model="ruleForm.client" :disabled="readonly" placeholder="请输入"
                                         :fetch-suggestions="queryClientsSearch"  value-key="company_name"
                                         @select="handleClientsSelect"></el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="client_contact" label="委托单位联系人" prop="client_contact">
                        <el-input v-model="ruleForm.client_contact" :disabled="readonly" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="client_phone" label="联系方式" prop="client_phone">
                        <el-input v-model="ruleForm.client_phone" :disabled="readonly" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item ref="undertaker" label="承办单位" prop="undertaker">
                        <el-autocomplete v-model="ruleForm.undertaker" :disabled="readonly" placeholder="请输入"
                                         :fetch-suggestions="queryUndertakerSearch" value-key="company_name"
                                         @select="handleUndertakerSelect"></el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="p_mid" label="申报项目负责人" prop="p_mid">
                        <el-select v-model="ruleForm.p_mid" :disabled="readonly" placeholder="请选择">
                            <el-option
                                v-for="item in members.filter(f=>{ return ruleForm.join_mid_str.indexOf(f.mid) === -1})"
                                :key="item.mid"
                                :label="item.name"
                                :value="item.mid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="pm_phone" label="联系方式" prop="pm_phone">
                        <el-input v-model="ruleForm.pm_phone" :disabled="readonly" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="join_mid_str" label="辅助申报人员" prop="join_mid_str">
                        <el-select v-model="ruleForm.join_mid_str" :disabled="readonly" multiple placeholder="请选择">
                            <el-option
                                v-for="item in members.filter(f=>{ return ruleForm.p_mid !== f.mid})"
                                :key="item.mid"
                                :label="item.name"
                                :value="item.mid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item ref="start_time" label="申报起始时间" prop="start_time">
                        <el-date-picker v-model="ruleForm.start_time"
                                        :disabled="readonly"
                                        :picker-options="{
                                            disabledDate(time) {
                                                return time.getTime() > new Date(ruleForm.end_time);
                                            }
                                        }"
                                        format="yyyy 年 MM 月 dd 日"
                                        placeholder="请选择"
                                        type="date" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="end_time" label="申报结束时间" prop="end_time">
                        <el-date-picker v-model="ruleForm.end_time"
                                        :disabled="readonly"
                                        :picker-options="{
                                            disabledDate(time) {
                                                return time.getTime() < new Date(ruleForm.start_time);
                                            }
                                        }"
                                        format="yyyy 年 MM 月 dd 日"
                                        placeholder="请选择"
                                        type="date" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item ref="p_money" label="申报项目金额" prop="p_money">
                        <el-input v-model="ruleForm.p_money" :disabled="readonly" placeholder="请输入" type="number">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-form-item label-width="0px">
                <div v-if="!readonly" class="flex justify-center margin-top">
                    <el-button :loading="requesting" class="btn max" type="primary" @click="submitForm('ruleForm')">
                        保存
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

import rules from "@/utils/rules";
import {filterDate, scrollIntoView, TOAST, toast} from "@/utils/utils";
import {addApplyProjectBasic, getAllMember, getCompanyList, getProjectCateList} from "@/api";

export default {
    components: {},
    name: "ProjectInfo",
    data() {
        return {
            ruleForm: {
                p_name: '',//	是项目名称
                p_code: '',//	123	Text	是项目编号
                cate:[],//项目分类  （多选逗号隔开ID）
                client: '',//	333	Text	是委托单位
                client_contact: '',//	3333	Text	是委托单位联系人
                client_phone: '',//	-	Text	是委托单位联系电话
                undertaker: '',//	-	Text	是承办单位
                p_mid: '',//	1	Text	是项目负责人
                pm_phone: '',//	-	Text	是联系电话
                start_time: '',//	-	Text	是开始时间
                end_time: '',//	-	Text	是结束时间
                p_money: '',//	-	Text	是项目金额
                join_mid_str: '',//	-	Text	是项目金额
            },
            rules: {
                p_name: [
                    {required: true, message: '请输入申报项目名称', trigger: 'blur'}
                ],
                // p_code: [
                //     {required: true, message: '请输入申报项目编码', trigger: 'blur'}
                // ],
                // client: [
                //     {required: true, message: '请输入委托单位', trigger: 'blur'}
                // ],
                // client_contact: [
                //     {required: true, message: '请输入委托单位联系人', trigger: 'blur'}
                // ],
                client_phone: [
                    // {required: true, message: '请输入委托单位联系方式', trigger: 'blur'}
                    rules.phone
                ],
                // undertaker: [
                //     {required: true, message: '请输入承办单位', trigger: 'blur'}
                // ],
                // p_mid: [
                //     {required: true, message: '请选择申报项目负责人', trigger: 'blur'}
                // ],
                pm_phone: [
                    // {required: true, message: '请输入申报项目负责人联系方式', trigger: 'blur'}
                    rules.phone
                ],
                // start_time: [
                //     {required: true, message: '请选择申报起始时间', trigger: 'blur'}
                // ],
                // end_time: [
                //     {required: true, message: '请选择申报结束时间', trigger: 'blur'}
                // ],
                p_money: [
                    // {required: true, message: '请输入申报项目金额', trigger: 'blur'},
                    rules.money
                ],
            },
            requesting: false,
            members: [],
            classifys: [],
            clients:[],
            undertakers:[]
        }
    },
    props: {
        detail: {
            type: Object
        },
        pid: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },
    computed: {},
    created() {
        this.init()
        if (this.detail) this.setData()
    },
    methods: {
        async init() {
            let _data = await getAllMember()
            this.members = _data.data
            _data = await getCompanyList(1,'',1,1000)
            if (_data.status === 200)this.clients = _data.data.data
            _data = await getCompanyList(2,'',1,1000)
            if (_data.status === 200)this.undertakers = _data.data.data
            _data = await getProjectCateList(1,1000)
            if (_data.status === 200)this.classifys = _data.data.data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitInfo()
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },
        async submitInfo() {
            this.requesting = true
            let _data = await addApplyProjectBasic(this.pid, this.ruleForm.p_name, this.ruleForm.p_code,this.ruleForm.cate.join(','), this.ruleForm.client,
                this.ruleForm.client_contact, this.ruleForm.client_phone, this.ruleForm.undertaker, this.ruleForm.p_mid,
                this.ruleForm.pm_phone, this.ruleForm.start_time, this.ruleForm.end_time, this.ruleForm.p_money,this.ruleForm.join_mid_str.join(','))
            if (_data.status === 200) {
                toast('保存成功', TOAST.success)
                this.$emit('watchState',true)
            } else {
                toast(_data.msg, TOAST.error)
            }
            this.requesting = false
        },
        async setData(){
            this.ruleForm = {
                p_name: this.detail.p_name,
                p_code: this.detail.p_code,
                cate: this.detail.cate ? this.detail.cate.split(',').map(item=>{ return Number(item)}) : [],
                client: this.detail.client,
                client_contact: this.detail.client_contact,
                client_phone: this.detail.client_phone,
                undertaker: this.detail.undertaker,
                p_mid: this.detail.p_mid || '',
                pm_phone: this.detail.pm_phone,
                start_time: filterDate(this.detail.start_time),
                end_time: filterDate(this.detail.end_time),
                p_money: this.detail.ex_money,
                join_mid_str: this.detail.join_mid_str ? this.detail.join_mid_str.split(',').map(Number) : [],
            }
        },
        queryClientsSearch(queryString, cb) {
            let restaurants = this.clients;
            let results = queryString ? restaurants.filter(this.createClientsFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createClientsFilter(queryString) {
            return (restaurant) => {
                return (restaurant.company_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleClientsSelect(item) {
           this.ruleForm.client =  item.company_name
        } ,
        queryUndertakerSearch(queryString, cb) {
            let restaurants = this.undertakers
            let results = queryString ? restaurants.filter(this.createUndertakerFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createUndertakerFilter(queryString) {
            return (restaurant) => {
                return (restaurant.company_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleUndertakerSelect(item) {
           this.ruleForm.undertaker = item.company_name
        }
    },
    watch: {
        detail() {
            if (this.detail) {
                this.setData()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {

}
</style>